import { Camera, ImageUp, Sparkles } from "lucide-react";

const MODES = [
  { id: "photo", label: "From a photo", hint: "Gemini renders your duck", Icon: Camera },
  { id: "render", label: "I have a render", hint: "Skip the AI — use my image", Icon: ImageUp },
];

// Step 1 source: let Gemini render the duck from a portrait, or bring a finished duck image and go straight to 3D.
export const SourceModeToggle = ({ value, onChange }) => (
  <div className="space-y-2">
    <div data-testid="source-mode" className="grid grid-cols-2 gap-2">
      {MODES.map(({ id, label, hint, Icon }) => {
        const active = value === id;
        return (
          <button
            key={id}
            type="button"
            data-testid={`source-${id}`}
            onClick={() => onChange(id)}
            className={`flex items-center gap-3 rounded-2xl px-4 py-3 text-left border transition-colors ${
              active ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border hover:border-primary"
            }`}
          >
            <Icon className="h-5 w-5 shrink-0" />
            <span className="min-w-0">
              <span className="block text-sm font-semibold">{label}</span>
              <span className={`block text-xs ${active ? "text-primary-foreground/80" : "text-muted-foreground"}`}>{hint}</span>
            </span>
          </button>
        );
      })}
    </div>
    {value === "render" && (
      <p data-testid="render-skip-hint" className="flex items-center gap-1.5 text-xs text-accent">
        <Sparkles className="h-3.5 w-3.5 shrink-0" /> Already have a render? We'll skip straight to the sculpt.
      </p>
    )}
  </div>
);

// Faithful mode: your render is reproduced as it is — no duck template (no added tail, wing bump, yellow body or
// outfit logic) is applied to someone else's design. ON by default for uploaded renders.
export const FaithfulToggle = ({ value, onChange }) => (
  <label
    data-testid="faithful-toggle"
    className="flex items-start gap-3 rounded-2xl border border-border bg-card/60 px-4 py-3 cursor-pointer"
  >
    <input
      type="checkbox"
      data-testid="faithful-checkbox"
      checked={value}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 h-4 w-4 accent-primary"
    />
    <span className="min-w-0">
      <span className="block text-sm font-semibold">Use my render exactly</span>
      <span className="block text-xs text-muted-foreground">
        Keeps every shape, fold, drape and colour from your image — no duck template, no added tail, wings or yellow body.
      </span>
    </span>
  </label>
);
